export const UTP = [
  {
    title: 'Прогноз прироста уникальных показов',
    description: 'Выбирайте продвижение с наибольшим количеством показов',
    imageClass: 'diagram',
  },
  {
    title: 'Еще больше эффективности за те же деньги',
    description: 'Продвигайте объявления в поиске, рекомендациях и даже на карте',
    imageClass: 'lightning',
  },
  {
    title: 'Точный эффект от продвижения',
    description: 'В прозрачной статистике показов объявлений',
    imageClass: 'arrow',
  },
];
